/**
 * Simple date utility to fix timezone display issues in lists
 */

/**
 * Formats ISO date strings for display without timezone conversion issues
 * Handles dates like "2025-06-26T15:17:16.669199Z" and "2025-06-26T00:00:00Z"
 */
export const formatDateForDisplay = (dateString: string | undefined | null): string => {
  if (!dateString) return '';

  try {
    // For ISO date strings, extract just the date part to avoid timezone conversion
    const date = new Date(dateString);

    // Add the timezone offset to counteract the automatic conversion
    const offsetMs = date.getTimezoneOffset() * 60 * 1000;
    const adjustedDate = new Date(date.getTime() + offsetMs);

    return adjustedDate.toLocaleDateString('en-US', {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};
